import { withJsonFormsControlProps } from '@jsonforms/react';
import { CheckboxesGrid } from './CheckboxesGrid';

const CheckboxesGridControl = ({ data, handleChange, path, schema, errors, visible }) => {
  return (
    <CheckboxesGrid
      value={data}
      updateValue={(newValue) => handleChange(path, newValue)}
      path={path}
      rows={schema?.rows ?? []}
      columns={schema?.columns ?? []}
      description={schema?.description ?? ''}
      limit={schema?.limit_one_per_column ?? false}
      errors={errors}
      visible={visible}
    />
  );
};

export default withJsonFormsControlProps(CheckboxesGridControl);
